<script setup lang="ts">
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import { type Radius, borderRadiusOptions } from "./index";
const borderRadius = defineModel<Radius>({
    default: "6px",
});
</script>
<template>
    <div>
        <p class="mt-4 text-lg font-medium">
            {{ $t("configurator.choose_border_radius") }}
        </p>

        <RadioGroup
            v-model="borderRadius"
            :default-value="borderRadius"
            class="mt-2"
        >
            <RadioGroupLabel class="sr-only">{{
                $t("configurator.choose_border_radius")
            }}</RadioGroupLabel>
            <div class="flex gap-2">
                <RadioGroupOption
                    v-for="option in borderRadiusOptions"
                    :key="option.radius"
                    v-slot="{ active, checked }"
                    as="template"
                    :value="option.radius"
                >
                    <div
                        :class="[
                            active ? 'ring-2  ring-iron-700 ' : '',
                            checked
                                ? 'bg-white  ring-2 ring-z-primary-500 '
                                : 'bg-white text-iron-900 ring-1  ring-iron-300 hover:bg-iron-50',
                            'flex items-center justify-center rounded-md px-4 py-2  text-sm font-semibold uppercase ',
                        ]"
                        :style="{
                            borderRadius: option.radius,
                        }"
                    >
                        <RadioGroupLabel as="span">{{
                            option.name
                        }}</RadioGroupLabel>
                    </div>
                </RadioGroupOption>
            </div>
        </RadioGroup>
    </div>
</template>
.
